const diverId = "35a7f298-304d-47a5-9929-9772867d5f48";
const divSupId = "ffe23bf1-46a3-4804-bb3e-87834832a100";

export const isDiver = (crewGroupId) => [diverId, divSupId].includes(crewGroupId);

export const isDivingSupervisor = (crewGroupId) => crewGroupId === divSupId;
